export default "__VITE_ASSET__58e81079__"